import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as DeliveryAssociateServices from "../../../service/master/DeliveryAssociateServices";
import { ChevronDownDDS } from "../../../asset";
import { Input } from "antd";

const DropdownSearchDriver = ({
  setValueDDS,
  children,
  valueDDS,
  className,
  togglerClassName,
  placeholder,
  filterBy,
  depotID,
  customFilter,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    limit: 100,
    filter: `depot_id eq ${depotID}, status eq Active`,
  });
  const [listData, setListData] = useState([]);
  const [dataSelected, setDataSelected] = useState();
  const [searchKeyword, setSearchkeyword] = useState("");

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getListData = useCallback(
    async (newParams) => {
      const { ok, list } = await DeliveryAssociateServices.dropdownDriver(
        token,
        newParams
      );
      if (ok && list !== null && list.length !== 0) {
        const newData = list.map((el) => {
          return {
            id: el.driver_id,
            value: `${el.driver_name} - ${el.vehicle_type} - ${el.vehicle_no}`,
          };
        });
        setListData(newData);
      } else {
        setListData([]);
      }
    },
    [token]
  );

  const onClickDataSelected = useCallback(
    (data) => {
      setDataSelected(data);
      setIsShowDropdownContent(false);
      setParams({ page: 1, limit: 100, filter: `depot_id eq ${depotID}, status eq Active` });
      setSearchkeyword("");
      setValueDDS(data?.id);
    },
    [depotID, setValueDDS]
  );

  const onChangeSearch = useCallback(
    (val) => {
      if (!val) {
        const resetParams = {
          page: 1,
          limit: 100,
          filter: `depot_id eq ${depotID}, status eq Active`,
        };
        setParams(resetParams);
        setSearchkeyword("");
        return;
      }
      const newParams = {
        ...params,
        filter: `depot_id eq ${depotID}, status eq Active, driver_name lk ${val}`,
      };
      setParams(newParams);
      setSearchkeyword(val);
    },
    [depotID, params]
  );

  useEffect(() => {
    if (!depotID) {
      return;
    }
    getListData(params);
  }, [depotID, getListData, params]);

  useEffect(() => {
    if (!valueDDS || valueDDS === null) {
      setDataSelected();
      return;
    }
    if (valueDDS && listData.length) {
      const dataSelected = listData.filter((el) => el.id === valueDDS);
      setDataSelected(dataSelected[0]);
    }
    return;
  }, [listData, valueDDS]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="w-full border border-gray-200 bg-white-100 flex justify-between px-[6px] rounded-md h-[40px] items-center"
        onClick={togglerDropdownContent}
      >
        <span
          className={"font-roboto text-xl text-black-300 font-medium px-2 truncate".concat(
            !dataSelected ? " text-opacity-50" : ""
          )}
        >
          {dataSelected ? dataSelected?.value : "Select Driver"}
        </span>
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div></div>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? " active mt-5" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="mt-2 px-2">
          <Input
            onChange={(evt) => {
              onChangeSearch(evt.target.value);
            }}
            value={searchKeyword}
            className="mb-2"
            placeholder="Search By Driver Name"
            size="large"
          />
        </div>
        <ul className="overflow-auto max-h-[300px]">
          {listData && listData.length !== 0 ? (
            listData.map((el, index) => (
              <li
                key={index}
                className="dropdown-item truncate"
                onClick={() => {
                  onClickDataSelected(el);
                }}
              >
                {el?.value}
              </li>
            ))
          ) : (
            <div className="flex w-full justify-center text-gray-600 font-bold text-base mb-5">
              No Data
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default DropdownSearchDriver;
